import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardMetrics } from '../../types';

interface AnalyticsState {
  metrics: DashboardMetrics | null;
  loading: boolean;
  error: string | null;
}

const initialState: AnalyticsState = {
  metrics: null,
  loading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setMetrics: (state, action: PayloadAction<DashboardMetrics>) => {
      state.metrics = action.payload;
      state.loading = false;
    },
    updateMetrics: (state, action: PayloadAction<Partial<DashboardMetrics>>) => {
      if (state.metrics) {
        state.metrics = { ...state.metrics, ...action.payload };
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearMetrics: (state) => {
      state.metrics = null;
    },
  },
});

export const { 
  setLoading, 
  setMetrics, 
  updateMetrics, 
  setError, 
  clearMetrics 
} = analyticsSlice.actions;
export default analyticsSlice.reducer; 